import React,{useEffect, useState} from 'react'
import Table from 'react-data-table-component';
import { Button, Tooltip } from 'reactstrap'; 
import { FiEdit } from "react-icons/fi";
import InsertDetialsOfRoi from './EditRoiSelectionModal/Index'
import { errorToast } from '../../../../../_helper/helper';
import { FaCircle } from "react-icons/fa";
import CameraService from '../../../../../api/cameraService';
import { generateTableData } from '../../../../../utils/formatDate';

const DataTableOfSelectedROI = ({ modules=[] , allCordinates,selectedmodules=[],setExtractTableData,type,NormaliseRoisData,userCurrentSelectedRoi }) => {
   const [tabelData, setTableData] = useState([]); 
   const [modalData, setmodalData] = useState({});
   const [modalOpen, setModalOpen] = useState(false);
   const toggleModal = () => setModalOpen(!modalOpen); 
   const [formData, setformData] = useState({
    model: "", 
    start_time: "",
    end_time: "",
    people: "",
    freq: "",
    level: "",
    color: "",
    alert:'',
    id:"",
    camera:"",
    roi:[],
    camera_brand:"",
   }) 

const handleEdit=(row)=>{ 
        setModalOpen(true);
        setmodalData(row);
        setformData({
            ...row,
            model: row.model, 
            id:row.id
        })
}
const handleSaveINFO = () => {
    if(!formData.alert || !formData.color || !formData.end_time || !formData.freq || !formData.level || !formData.model || formData.roi?.length<=0 || !formData.start_time){
        return errorToast('Please fill all the fields')
    }
    setTableData(prevTableData => 
        prevTableData.map(item => 
            item.id === formData.id ? formData : item
        )
    );
    toggleModal()
};

const tableColumns = [
    {
        name: "ROI",
        cell: row => (
            <div className='d-flex gap-1'> 
                {row.roi?.map((item,key)=>(
                    <p className='m-0 b-r-10 text-center' style={{ background:"#175fa4",color:'white',width:'30px'}}>{item.name}
                    {/* {key==row.roi?.length-1 ? null : ', '}  */}
                    </p>
                ))}
            </div>
        ),
    },
    {
        name: "Model",
        cell: row => (
            <div> 
                {row.model}
            </div>
        ),
    },
    {
        name: "Start Time",
        selector: (row) => row.start_time,
    },
    {
        name: "End Time",
        selector: (row) => row.end_time,
    },
    {
        name: "People",
        selector: (row) => row.people,
        center: true,
    }, 
    {
        name: "Freq(mins)",
        cell: (row) => (
            <div>
                {row.freq} 
            </div>
        ),
        center: true,
    },
    {
        name: "Non-Compliance",
        cell: (row) => (
            <div>
                {row.alert} 
            </div>
        ),
        center: true,
    },
    {
        name: "Alerts Level",
        cell: (row) => (
            <div>
                {row.level} 
            </div>
        ),
        center: true,
    },
    {
        name: "Color",
        cell: row => (
            <div> 
                 <FaCircle color={row.color } />
            </div>
        ),
    },
    // {
    //     name: "Camera Brand",
    //     cell: row => (
    //         <div> 
    //            {row.camera_brand } 
    //         </div>
    //     ),
    // },
    {
        name: "Actions",
        cell: row => (
            <div> 
                <button className='btn' onClick={()=>{handleEdit(row)}}>
                 <FiEdit/> Edit
                </button>
            </div>
        ),
    },
];
useEffect(() => {    
    console.log("----------------------------")
    console.log(userCurrentSelectedRoi)
   const tableData = generateTableData({
    type,
    modules,
    selectedmodules,
    NormaliseRoisData,
    userCurrentSelectedRoi
    });

    setTableData(tableData);

}, [modules, selectedmodules,userCurrentSelectedRoi]);
 
useEffect(() => {
    setExtractTableData(tabelData)
}, [tabelData])

    return (
        <div>
             <Table data={tabelData} columns={tableColumns} height={50}
            //   customStyles={customStyles} 
            />
            <InsertDetialsOfRoi isOpen={modalOpen} toggle={toggleModal} formData={formData} modalData={modalData} setformData={setformData} moduleOptions={modules} allCordinates={allCordinates} handleSaveINFO={handleSaveINFO} />
        </div>
    )
}
export default DataTableOfSelectedROI